import { useEffect, useState} from 'react';
import CartStore from "stores/new/Cart";
import CartAction from "actions/Cart";
import PubSub from 'services/PubSub';
import { actionsType } from 'config/constants';
import PropTypes from 'prop-types';

const QuickPurchaseCheckout = (props) => {

    let actions = [];

    const [orderForm, setOrderForm] = useState(null);
    const [receiverData, setReceiverData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { cart } = props;

    useEffect(() => {
        CartAction.getCart();

        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            setTimeout(() => {
                CartAction.getCart();
            },0);
        }));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[]);

    useEffect(()=> {
        if(cart){
            setOrderForm(cart.orderForm ? cart.orderForm : null);
            setLoading(cart.loading);
            setReceiverData(cart.receiverData);
        }
    },[cart]);

    const propsComponent = {
        orderForm,
        loading,
        receiverData
    };

    return props.children && props.children(propsComponent) || '';
}

QuickPurchaseCheckout.propTypes = {
    cart: PropTypes.object
};

export default CartStore.wrapConsumer(QuickPurchaseCheckout);
